const req = require.context('.', true, /^(?!.\/index).*.js$/);

req.keys().forEach(key => {
  const containerName = key.replace(/^.+\/([^/]+)\.js/, '$1');
  module.exports[containerName] = req(key).default;
});



// WEBPACK FOOTER //
// ./src/script/containers/index.js